import ActionButton from '@/components/bundles/share/grid/ActionButton'

export default {
  computed: {
    gridColumns () {
      return [
        {
            id: 0,
            data: 'DT_RowId',
            searchable: false,
            orderable: false,
            render: (data, type, row) => {
              return ActionButton.renderActionButtons(data, type, row, this.gridActions, this)
            }
          },
          {
            id: 1,
            data: 'taskNumber',
            title: 'NR CRLS',
            render: (data, type, row, meta) => {
              return data !== null ? data : row.id
            }
          },
          { id: 2, data: 'assignee', title: 'OPIEKUN', sortable: false },
          { id: 3, data: 'state', title: 'STATUS' },
          {
            id: 4,
            data: 'createdAt',
            title: 'UTWORZONO',
            render: (data) => {
              return this.formatDate(data)
            }
          },
        { id: 5, data: 'address', title: 'ADRES' },
        { id: 6, data: 'voivodeship', title: 'WOJEWÓDZTWO' },
        { id: 7, data: 'customerSurname', title: 'NAZWISKO KLIENTA' },
        { id: 8, data: 'closedAt', title: 'PIERWSZE PRZEKAZANIE' },
        { id: 9, data: 'lastClosedAt', title: 'OSTATNIE PRZEKAZANIE' },
        { id: 10, data: 'priority', title: 'PRIORYTET' },
        { id: 11, data: 'market', title: 'RYNEK' },
        { id: 12, data: 'typeOfStudy', title: 'RODZAJ OPRACOWANIA' },
        ]
    }
  }
}
